export default __webpack_public_path__ + "static/icon-zonav-dis-9f03136de83a4b94aaa64397d2e976c1.png";